import React from "react"
import styled from "styled-components"

const ColorBurnWrapper = styled.g`
  .st2 {
    fill: none;
  }
  .st5 {
    fill: #0f2e3f;
  }
  .st14 {
    fill: none;
    stroke: #fff;
    stroke-width: 2;
  }
  .st18,
  .st19,
  .st22,
  .st23 {
    stroke: #000;
  }
  .st18 {
    stroke-width: 2;
    fill: none;
  }
  .st19,
  .st22,
  .st23 {
    fill: #fff;
  }
  .st22,
  .st23 {
    fill: none;
    stroke-width: 0.5;
  }
  .st23 {
    stroke: #fff;
    stroke-width: 5;
  }

  text {
    fill: #fff;
    font-size: 3rem;
  }
`

const ColorBurnIcon = () => (
  <ColorBurnWrapper>
    <circle className="icon-bg" cx="150" cy="150" r="150" />
    <filter id="AI_GaussianBlur_7">
      <feGaussianBlur stdDeviation="7" />
    </filter>
    <filter
      id="AI_Alpha_4"
      width="100%"
      height="100%"
      x="0%"
      y="0%"
      filterUnits="objectBoundingBox"
    >
      <feTurbulence
        baseFrequency=".1"
        numOctaves="4"
        result="turb"
        type="fractalNoise"
      />
      <feComposite in="SourceGraphic" in2="turb" operator="in" />
    </filter>

    <g id="backblast_1_">
      <path
        d="M195.27 291.99c5.18-1.65 10.23-3.57 15.14-5.75l-27.38-47.85 12.24 53.6zM169.33 297.75c5.39-.7 10.69-1.69 15.88-2.95l-18.05-51.87 2.17 54.82zM276.34 70.99c-3.26-5.21-6.84-10.2-10.7-14.95l-43.84 44.85 54.54-29.9zM259.35 48.81c-4.22-4.55-8.71-8.84-13.46-12.84l-35.25 52.75 48.71-39.91zM238.43 30.08c-5.03-3.72-10.31-7.12-15.79-10.19l-25.21 58.9 41-48.71zM187.69 5.81c-6.09-1.59-12.33-2.8-18.7-3.61l-2.25 64.78 20.95-61.17zM219.78 281.67c4.81-2.56 9.47-5.36 13.95-8.41l-35.93-42.28 21.98 50.69zM214.27 15.54c-5.67-2.72-11.54-5.08-17.58-7.07l-14.06 62.99 31.64-55.92zM242.11 267.13c4.31-3.39 8.42-7.02 12.32-10.86L210.96 221l31.15 46.13zM296.43 122.35c-1.11-5.91-2.56-11.7-4.35-17.34l-55.55 25.29 59.9-7.95zM289.3 202.96c2.01-5.29 3.74-10.72 5.14-16.28l-57.8-7.39 52.66 23.67zM299 149.67c-.01-5.94-.38-11.8-1.07-17.57l-58.32 14.42 59.39 3.15zM296.58 176.84c1.02-5.63 1.72-11.37 2.1-17.2l-59.04 3.41 56.94 13.79zM277.47 227.19c2.9-4.78 5.54-9.75 7.9-14.86l-54.65-17.62 46.75 32.48zM288.83 95.8c-2.21-5.67-4.76-11.16-7.62-16.46l-50.68 35.58 58.3-19.12zM159.67 1.32c-3.2-.2-6.42-.32-9.67-.32-3.16 0-6.3.11-9.42.3l9.7 64.19 9.39-64.17zM261.54 248.78c3.67-4.14 7.12-8.48 10.31-13.02l-49.8-26.99 39.49 40.01zM116.39 295.19c5.22 1.2 10.55 2.12 15.96 2.76l1.91-54.94-17.87 52.18zM28.83 236.73c3.28 4.57 6.8 8.95 10.56 13.11l39.81-40.73-50.37 27.62zM46.53 257.2c3.98 3.85 8.18 7.47 12.58 10.86l31.26-46.77-43.84 35.91zM15.06 213.25c2.43 5.18 5.15 10.19 8.14 15.02l47.27-33.18-55.41 18.16zM5.76 187.49c1.46 5.64 3.25 11.15 5.33 16.51l53.38-24.3-58.71 7.79zM91.03 286.86c4.97 2.14 10.07 4.03 15.3 5.63l12.04-53.95-27.34 48.32zM67.49 274.08c4.55 3.03 9.28 5.82 14.16 8.35l21.92-51.22-36.08 42.87zM150.71 244.5l-7.95 54.32c2.4.11 4.81.18 7.23.18 2.99 0 5.96-.1 8.91-.27l-8.19-54.23zM1.36 160.3c.4 5.93 1.16 11.76 2.23 17.47l57.8-14.3-60.03-3.17zM7.83 105.3c-1.8 5.73-3.26 11.62-4.36 17.63l60.89 7.78L7.83 105.3zM18.72 79.47c-2.9 5.38-5.47 10.96-7.7 16.72l59.26 19.11-51.56-35.83zM34.36 56.05c-3.91 4.81-7.53 9.87-10.82 15.15l55.41 30.04-44.59-45.19zM54.19 35.9c-4.8 4.04-9.35 8.37-13.6 12.98L90.04 89 54.19 35.9zM2.02 132.58C1.35 138.3 1 144.11 1 150c0 .15.01.29.01.44l60.35-3.48-59.34-14.38zM77.52 19.8c-5.54 3.09-10.86 6.52-15.93 10.26l41.61 48.96L77.52 19.8zM103.54 8.4c-6.08 1.99-11.98 4.36-17.69 7.09l32.11 56.14L103.54 8.4zM131.28 2.17c-6.39.8-12.65 2.01-18.76 3.59l21.33 61.3-2.57-64.89z"
        className="st2"
      />
      <path
        fill="#ccc"
        d="M158.91 298.73c3.5-.21 6.98-.53 10.41-.97l-2.17-54.81 18.05 51.87c3.4-.82 6.76-1.76 10.06-2.81l-12.23-53.61 27.38 47.85c3.18-1.41 6.31-2.94 9.37-4.56L197.8 231l35.93 42.28c2.86-1.95 5.66-3.99 8.38-6.13L210.96 221l43.47 35.27c2.45-2.41 4.83-4.91 7.11-7.49l-39.48-40.01 49.8 26.99c1.97-2.79 3.84-5.65 5.62-8.57l-46.76-32.49 54.65 17.62c1.42-3.07 2.73-6.19 3.94-9.37l-52.66-23.67 57.8 7.39c.82-3.24 1.53-6.52 2.14-9.84l-56.94-13.79 59.04-3.41c.2-3.19.32-6.4.32-9.64v-.33l-59.39-3.14 58.32-14.42c-.39-3.29-.89-6.54-1.5-9.75l-59.9 7.95 55.55-25.29c-.99-3.11-2.07-6.18-3.25-9.21l-58.31 19.11 50.68-35.58c-1.53-2.84-3.16-5.62-4.87-8.35l-54.54 29.9 43.84-44.85c-2.02-2.48-4.11-4.89-6.28-7.23l-48.71 39.91 35.25-52.75c-2.42-2.04-4.91-4-7.46-5.89l-41 48.71 25.21-58.9c-2.74-1.53-5.53-2.99-8.37-4.35l-31.64 55.92L196.7 8.46c-2.96-.98-5.96-1.87-9-2.66l-20.96 61.17 2.25-64.78c-3.08-.39-6.18-.68-9.31-.88l-9.39 64.18-9.7-64.19c-3.13.2-6.23.48-9.31.86l2.57 64.89-21.33-61.3c-3.03.79-6.02 1.67-8.97 2.64l14.43 63.22-32.13-56.13c-2.83 1.35-5.6 2.79-8.33 4.31l25.68 59.22-41.61-48.95c-2.53 1.87-5 3.82-7.41 5.84L90.04 89 40.58 48.88c-2.15 2.32-4.22 4.72-6.22 7.17l44.59 45.18L23.53 71.2c-1.69 2.7-3.3 5.46-4.81 8.28l51.56 35.83-59.26-19.12c-1.16 2.99-2.23 6.03-3.2 9.12l56.53 25.41-60.89-7.78c-.58 3.18-1.06 6.4-1.44 9.65l59.34 14.37-60.35 3.48c.01 3.31.13 6.6.35 9.86l60.04 3.18-57.8 14.3c.62 3.28 1.34 6.52 2.17 9.72l58.71-7.79L11.09 204c1.22 3.14 2.55 6.22 3.97 9.25l55.41-18.16-47.27 33.18c1.78 2.88 3.66 5.71 5.63 8.46l50.37-27.62-39.8 40.73c2.29 2.54 4.67 4.99 7.13 7.36l43.84-35.91-31.27 46.77c2.72 2.1 5.52 4.11 8.38 6.02l36.08-42.86-21.92 51.22c3.07 1.59 6.19 3.06 9.38 4.44l27.34-48.33-12.04 53.95c3.31 1.01 6.66 1.92 10.06 2.7l17.87-52.17-1.91 54.94c3.44.41 6.91.7 10.41.87l7.95-54.32 8.21 54.21z"
      />
    </g>
    <g id="fire_1_">
      <g id="puff_1_" filter="url(#AI_GaussianBlur_7)">
        <path
          d="M195.23 22.76c-28.13-7.4-45.29.89-73.41-6.53-20.49.55-29.89 8.34-37.4 11.92 0 0-27.29 12.71 25.95 20.8 53.24 8.1 53.24 4.17 78.36-2.95 17.93-5.09 14.8-17.1 6.5-23.24z"
          className="st5"
        />
      </g>
      <path
        fill="#f2665a"
        d="M197.18 39.86c-34.11 25.98-62.65 28.98-81.04-9.94-16.84 17.89-30.07 9.6-52.19-.02 6.09 10.63-7.11 23.33-18.9 14.93C57.9 81.98 67 131.58 112.22 138.47c25.87 3.94 22.34 30.12 33.49 45.18 47.57-28.87 75.63-117.1 88.29-156.26-2.04-2.01-24.71 19.05-36.82 12.47z"
      />
      <g id="smoke_1_" filter="url(#AI_Alpha_4)">
        <path
          d="M148.13 2.56C92.44 0 43.33 46.15 41.6 48.24l23.36 54.05 149.35-9.34 20.14-65.79C230.92 24.2 197.31 1 148.13 2.56z"
          className="st5"
        />
      </g>
      <path
        fill="#fc96ff"
        d="M55.86 68.31c33.47 29.55 52.33 36.75 42.62.25 19.28 18.31 36.97 17.87 52.92-3.07 10.64 27.88 27.19 25.7 46.99 7.06 10.08 6.76 18.66-1.96 26.55-17.92 0 0-28.65 141.04-85.91 128.28-57.24-12.77-83.17-114.6-83.17-114.6z"
      />
      <path
        fill="#ff7f52"
        d="M124.15 159.06c11.33-9.23 10.48-33.18 33.35-51.08-8.51 2.2-15.68-1.68-20.98-14.15-12.43 14.66-26.22 14.97-41.26 2.13 7.59 25.58-7.12 20.52-33.23-.2 0 0 10.83 38.15 34.1 62.17 13.08 8.95 18.9 8.56 28.02 1.13z"
      />
      <path
        fill="#c73820"
        d="M132.75 126.26c4.58-6.4-12.59-11.45-18.89-17.18 9.76 3.98 18.01.87 24.06-12.7 12.31 14.58 26.13 15.04 41.33 2.58-7.87 25.08 6.93 20.28 33.3.2 0 0-12.51 41.62-38.8 64.48-21.9-9.58-57.43-14.4-41-37.38z"
      />
      <path
        fill="#78c5ff"
        d="M76.75 128.05c11.25 10.83 16.36 9.65 17.19.1 8.02 4.73 14.2 5.68 17.19.1 19.81 10.94 28.42 10.82 27.49 1.29 12.81 9.43 25.82 9.36 38.94 3.62 4.46 10.88 11.32 9.56 20.65-4.39 0 0 3.22 42.9-49.51 45.4-52.72 2.51-68.61-26.36-71.95-46.12z"
      />
      <path
        fill="#fdff00"
        d="M83.1 140.74c14.45 11.02 23.04 7.36 28.02-5.37 7.68 14.91 14.67 14.24 21-1.46 5.38 12.67 13.4 11.37 22.98 1.72-4.7 13.72 1.26 16.24 15.94 9.59 0 0-17.17 33.14-44.14 29.82s-43.8-34.3-43.8-34.3z"
      />
    </g>
    <g id="perspective_blender_2_">
      <g id="panels_2_">
        <linearGradient
          id="burn-blender-body"
          x1="158.377"
          x2="158.377"
          y1="152.9644"
          y2="305.1176"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#940025" />
          <stop offset=".0184" stopColor="#9b0a23" />
          <stop offset=".2451" stopColor="#e57009" />
          <stop offset=".3739" stopColor="#ff9500" />
          <stop offset=".4528" stopColor="#ffaf3d" />
          <stop offset=".6069" stopColor="#ffd69d" />
          <stop offset=".762" stopColor="#fff0dc" />
          <stop offset=".9191" stopColor="#fffdfb" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <path
          fill="url(#burn-blender-body)"
          stroke="#fff"
          strokeWidth="3"
          d="M238.93 267.92c1.26-.95 2.53-1.86 3.8-2.7.75-.49 1.55-1.01 2.38-1.51.76-1.03 1.35-1.78 1.63-2.11.93-1.11 1.94-2.21 2.97-3.29-1.49-22.71-9.45-54.16-26.47-90.31-23.93-12.75-54.99-15.71-66.8-14.92-23.85 1.59-49.13 15.04-71.66 32.2-11.92 28.85-17.64 62.7-17.71 85.68 14.45 8.54.45-.46 14.84 8.97 17.56-7.34 65.19-20.32 77.69-22.39 14.35-2.38 58.1 1.59 78.61 10.85.22-.16.46-.31.72-.47z"
        />
      </g>
      <path
        d="M245.55 121.41c2.41-41.27 9.92-100.27-31.95-77.46l-3.37 4.65s2.24 5.78 3.1 7.27c23.2-31.01 26.24 55.84 13.08 68.48-2.56 2.46-16.03 7.79-16.7 9.86-1.64 5.14-2.9 17.97-2.9 17.97 5.8-17.37 28.11-14.01 38.74-30.77z"
        className="st14"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeWidth="3"
        d="M83.46 183.93c-3.24-7.95-7.17-15.58-10.38-23.53-3.22-7.99-5.99-16.16-8.36-24.44-4.8-16.81-7.89-34.08-9.78-51.45-.51-4.72-.21-10.11-1.32-14.7-.89-3.68-6.48-6.23-10.08-5.83.29-.52 2.81-5.11 3.32-3.07.39 1.57-2.06 3.15-3.32 3.07 9.54-16.97 23.9-28.86 41.4-37.2 5.14-2.45 10.43-4.56 15.8-6.43 33.34-8.85 67.61-8.71 102.68-.86 10.79 4.01 21.81 7.15 30.47 14.22 3.15 44.77 1.57 89.53-10.95 132.48"
      />
      <g id="measurelines_2_">
        <path
          d="M62.19 77.73s6.45-11.78 19.76-17.44M81.92 151.52S63.79 127.3 61.98 75.98M61.9 90.01s3.39-11.09 15.85-18.34M63.96 99.64c1.73-5.11 8.95-12.32 14.21-15.12M66.11 110.49c1.13-3.34 8.85-13.54 13.77-14.86M69.47 121.04c2.25-5.51 8.92-13.35 15.12-14.36M73.49 132c1.25-3.97 7.24-11.02 10.92-11.83M76.42 141.24s2.74-9.97 15.38-15.3M81.13 151.64s7.46-10.76 20.11-16.08"
          className="st14"
        />
      </g>
      <path
        id="bottom_1_"
        fill="#4d4d4d"
        stroke="#fff"
        strokeWidth="2"
        d="M223.48 278.48c1.57-1.03 3.34-2.15 5.22-3.1 2.52-2.16 5.14-4.17 7.78-5.9.68-.44 1.39-.91 2.14-1.36-17-6-45.63-9.71-79.9-9.58-.03 0-.06.01-.09.01-16.79 1.72-62.4 14.91-75.34 22.4-.39.22-.34.78.1.82 12.77 1.16 57.25 11.24 65.87 11.24 23.21 0 47.67-6.27 71.1-12.33 1.03-.77 2.07-1.52 3.12-2.2z"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeWidth="4"
        d="M150.05 153.78s13.85 46.82 9.91 103.36"
      />
    </g>
    <g id="face_1_">
      <g id="brows_1_">
        <path
          d="M93.53 191.23c2.59-1.76 4.68 16.53 16.67-7.38M115.51 180.72c-1.83 4.68-3.09 15.59 26.24-11.8"
          className="st18"
        />
      </g>
      <path
        d="M101.04 195.62c-.62.01-1.22.12-1.84.13-.71.01-1.34-.27-1.87-.69-2.19 2.8-3.92 7.7-4.12 12.27-.25 5.81 2.04 8.83 5.14 6.52 3.09-2.31 5.61-8.91 5.64-14.54.01-1.95-.29-3.52-.81-4.64-.56.57-1.3.94-2.14.95zM119.12 186.06c-.56.19-1.08.22-1.54.13-1.02 2.69-1.71 5.75-1.84 8.7-.29 6.63 2.33 10.07 5.85 7.44 3.52-2.63 6.4-10.16 6.43-16.58.01-1.65-.18-3.05-.51-4.19-2.1 2.44-5.42 3.51-8.39 4.5z"
        className="st19"
      />
      <path d="M100.56 202.11c-.01 2.05-.93 4.45-2.05 5.28-1.12.84-1.96-.26-1.87-2.37.09-2.03 1-4.24 2.05-5.01 1.04-.77 1.88.14 1.87 2.1zM125.38 187c-.02 3.29-1.49 7.16-3.3 8.51-1.81 1.35-3.15-.42-3-3.82.14-3.26 1.62-6.82 3.29-8.07 1.68-1.24 3.02.22 3.01 3.38z" />
      <g id="mouth_1_">
        <path
          fill="#fff"
          d="M139.99 221.91c-.51 23.13-14.74 21.04-30.24 24.68-9.66 2.27-26.41 22.35-26.21 11.03.2-11.34 5.77-31.49 26.83-42.61 24.08-12.72 29.87-4.56 29.62 6.9z"
        />
        <path
          fill="none"
          stroke="#000"
          d="M83.53 257.62c-4.94-.51 36.28-46.81 55.42-28.65"
        />
        <path d="M94.93 261.75s8-11.17 22.38-13.17c11.87-1.65 6.86-.39 6.86-.39-12.8 4.24-23.42 8.94-29.24 13.56z" />
        <path
          d="M87.27 244.6l-1.07 13.3M90.91 242.23l-.48 7.84M135.56 221.8l-.79 4.5v7.28M127.68 221.01l-.79 3.99M121.79 226.15l.57 4.29M96.97 235.94v4.71M93.03 248.5v-4.05M126.52 224.58l1.35 6.64M117.85 222.98l.57 3.53"
          className="st22"
        />
      </g>
    </g>
    <g id="arms_1_">
      <path
        d="M75.88 211.17c-7.78-14.32-12.89-29.45-19.73-44.51-1.17-2.04 2.58-3.24 2.71-5.63M52.65 161.8l3.28 3.98M50.06 164.07l4.79 2.82M174.71 190.49l16.52-76.8 5.29-2.24M191.55 108.79l.16 5.05M188.39 109.3l1.91 4.89"
        className="st23"
      />
    </g>
  </ColorBurnWrapper>
)

export default ColorBurnIcon
